import styled from 'styled-components';

export const CartItemsCountContainer = styled.div`
  position: absolute;
  right: 1.2rem;
  top: 50%;
  transform: translateY(-50%);
  height: 3rem;

  img {
    width: auto;
    height: 3rem;
    display: block;
  }
`;

export const CartItemsCount = styled.p`
  font-family: ${props => props.theme.fonts.circular};
  font-weight: 700 !important;
  line-height: 1.25 !important;
  letter-spacing: normal !important;
  margin-top: 0.2rem !important;
  color: #0f3c6c !important;
  position: absolute !important;
  top: 50%;
  left: 46%;
  transform: translate(-50%, -50%);
`;
